"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaLeft = _interopRequireDefault(require("UIComponents/layout/UIMediaLeft"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UINanoProgress = _interopRequireDefault(require("UIComponents/progress/UINanoProgress"));

var _image = require("FileManagerCore/utils/image");

var _file = require("FileManagerCore/utils/file");

var _FileTypeIcon = _interopRequireDefault(require("FileManagerCore/components/FileTypeIcon"));

var _InfoIcon = _interopRequireDefault(require("FileManagerLib/components/browser/InfoIcon"));

var _VideoIconOverlay = _interopRequireDefault(require("FileManagerCore/components/VideoIconOverlay"));

var _Constants = require("FileManagerCore/Constants");

var THUMB_SIZE = 30;

var File =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(File, _Component);

  function File(props) {
    var _this;

    (0, _classCallCheck2.default)(this, File);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(File).call(this, props));
    _this.handleSelect = _this.handleSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInfoIconSelect = _this.handleInfoIconSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowSelect = _this.handleRowSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(File, [{
    key: "getFormattedExtension",
    value: function getFormattedExtension(file) {
      var extension = file.get('extension');

      if (extension) {
        return "." + extension;
      }

      return '';
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(event) {
      var usageTrackingMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      event.stopPropagation();
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          file = _this$props.file,
          selected = _this$props.selected;

      if (selected) {
        onSelect(null, usageTrackingMeta);
      } else {
        onSelect(file, usageTrackingMeta);
      }
    }
  }, {
    key: "handleInfoIconSelect",
    value: function handleInfoIconSelect(event) {
      this.handleSelect(event, {
        target: 'file-info-icon'
      });
    }
  }, {
    key: "handleRowSelect",
    value: function handleRowSelect(event) {
      if (!this.props.isUploading) {
        this.handleSelect(event, {
          target: 'file-row'
        });
      }
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(event) {
      var _this$props2 = this.props,
          onInsert = _this$props2.onInsert,
          file = _this$props2.file,
          isUploading = _this$props2.isUploading;

      if (!isUploading) {
        event.stopPropagation();
        onInsert(file);
      }
    }
  }, {
    key: "renderFileTypeIcon",
    value: function renderFileTypeIcon(file) {
      return _react.default.createElement(_FileTypeIcon.default, {
        size: 20,
        file: file,
        draggable: false
      });
    }
  }, {
    key: "renderFileThumbnail",
    value: function renderFileThumbnail(file) {
      var dimensions = (0, _image.scaleToFit)(file, THUMB_SIZE);
      return _react.default.createElement("div", {
        className: "file-thumbnail-wrapper"
      }, (0, _file.getFileType)(file) === _Constants.FileTypes.MOVIE && _react.default.createElement(_VideoIconOverlay.default, null), _react.default.createElement("img", {
        className: (0, _classNames.default)('file-manager-file__thumbnail', {
          'is-shutterstock': (0, _image.isShutterstock)(file)
        }),
        style: dimensions,
        src: (0, _file.getImageSrc)(file),
        draggable: false
      }));
    }
  }, {
    key: "renderInfoButton",
    value: function renderInfoButton() {
      return _react.default.createElement(_UIMediaRight.default, {
        className: "file-manager-file__info-icon-wrapper"
      }, _react.default.createElement(_UILink.default, {
        className: "file-manager-file__info-link",
        use: "unstyled",
        onClick: this.handleInfoIconSelect
      }, _react.default.createElement(_InfoIcon.default, {
        className: "file-manager-file__info-icon",
        color: colors.CALYPSO
      })));
    }
  }, {
    key: "renderUploadProgress",
    value: function renderUploadProgress() {
      var uploadProgress = this.props.uploadProgress;
      return _react.default.createElement("div", {
        className: "file-upload-progress-container"
      }, _react.default.createElement(_UINanoProgress.default, {
        color: colors.CALYPSO,
        value: uploadProgress
      }));
    }
  }, {
    key: "renderUploadOverlay",
    value: function renderUploadOverlay() {
      return _react.default.createElement("div", {
        className: "thumbnail__preview-overlay"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          file = _this$props3.file,
          selected = _this$props3.selected,
          last = _this$props3.last,
          isUploading = _this$props3.isUploading;
      return _react.default.createElement("div", {
        className: (0, _classNames.default)('file-manager-file', {
          'is-selected': selected,
          'is-last': last
        }),
        onClick: this.handleRowSelect
      }, isUploading && this.renderUploadOverlay(), _react.default.createElement(_UIMedia.default, {
        className: "file-manager-file__file-details",
        align: "center"
      }, _react.default.createElement(_UIMediaLeft.default, null, (0, _file.getHasThumbnail)(file) ? this.renderFileThumbnail(file) : this.renderFileTypeIcon(file)), _react.default.createElement(_UIMediaBody.default, {
        className: (0, _classNames.default)('flex-grow', 'file-manager-file__file-name')
      }, _react.default.createElement(_UILink.default, {
        onClick: this.handleInsert
      }, _react.default.createElement(_UITruncateString.default, {
        tooltip: false,
        useFlex: true
      }, file.get('name'), this.getFormattedExtension(file))), isUploading && this.renderUploadProgress()), !isUploading && this.renderInfoButton()));
    }
  }]);
  return File;
}(_react.Component);

File.propTypes = {
  file: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  selected: _react.PropTypes.bool.isRequired,
  last: _react.PropTypes.bool.isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  isUploading: _react.PropTypes.bool.isRequired,
  uploadProgress: _react.PropTypes.number
};
var _default = File;
exports.default = _default;
module.exports = exports.default;